import { render, staticRenderFns } from "./UserPreferences.vue?vue&type=template&id=2f16b762&scoped=true"
import script from "./UserPreferences.vue?vue&type=script&lang=js"
export * from "./UserPreferences.vue?vue&type=script&lang=js"
import style0 from "./UserPreferences.vue?vue&type=style&index=0&id=2f16b762&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f16b762",
  null
  
)

export default component.exports